// src/components/QrCodeWithLogo.jsx
import React, { forwardRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

/**
 * Componente oficial de Código QR con logotipo central 'Big.png'
 * Implementa nivel de redundancia 'H' (30%) y excavación central
 * para lectura de alta velocidad en puertas del Estadio Caliente.
 */
const QrCodeWithLogo = forwardRef(function QrCodeWithLogo(
  {
    value,
    size = 240,
    className = '',
    id = 'ticket-qr-canvas',
    logoSrc = '/img/Big.png',
    logoScale = 0.24,
    bgColor = '#ffffff',
    fgColor = '#09090b',
    ariaLabel = 'Código QR de acceso oficial'
  },
  ref
) {
  const logoDimension = Math.round(size * logoScale);

  return (
    <div
      className={`qr-code-wrapper d-inline-flex align-items-center justify-content-center p-2 rounded-3 ${className}`}
      style={{
        backgroundColor: bgColor,
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.45)',
        maxWidth: '100%'
      }}
      role="img"
      aria-label={ariaLabel}
    >
      <QRCodeCanvas
        ref={ref}
        id={id}
        value={value || 'XOLOFEST-2026-TICKET'}
        size={size}
        level="H"
        bgColor={bgColor}
        fgColor={fgColor}
        marginSize={1}
        imageSettings={{
          src: logoSrc,
          height: logoDimension,
          width: logoDimension,
          excavate: true
        }}
        style={{
          width: '100%',
          maxWidth: `${size}px`,
          height: 'auto',
          display: 'block'
        }}
      />
    </div>
  );
});

export default QrCodeWithLogo;
